import React, { Component } from "react";
import "../../App.css";
import { getQueuedOrders } from "../../Api/Http";

// Groups the flat queue array (scripts/orders.js orderQueue redis key) by tradingsymbol so the
// page can show one row per symbol with an expandable raw-JSON view of its queued order(s).
const groupByTradingsymbol = orders => {
    const groups = {};
    (orders || []).forEach(order => {
        const key = order.tradingsymbol || "UNKNOWN";
        if (!groups[key]) groups[key] = [];
        groups[key].push(order);
    });
    return Object.keys(groups)
        .sort()
        .map(tradingsymbol => ({ tradingsymbol, orders: groups[tradingsymbol] }));
};

class QueuedOrders extends Component {
    state = { groups: [], expanded: null };

    async componentDidMount() {
        const resp = await getQueuedOrders();
        const orders = (resp && resp.data) || [];
        this.setState({ groups: groupByTradingsymbol(orders) });
    }

    toggleExpanded = tradingsymbol => {
        this.setState(prev => ({ expanded: prev.expanded === tradingsymbol ? null : tradingsymbol }));
    };

    render() {
        const { groups, expanded } = this.state;
        return (
            <div>
                <header>
                    <h1>Queued Orders ({groups.length})</h1>
                </header>
                <div className="triggers-table">
                    <table className="queued-orders-table">
                        <tbody>
                            <tr>
                                <th className="positions-orders-table-heading">Symbol</th>
                                <th className="positions-orders-table-heading">Queued Count</th>
                                <th className="positions-orders-table-heading">Details</th>
                            </tr>
                            {groups.length === 0 && (
                                <tr>
                                    <td className="positions-orders-table-cell" colSpan={3}>
                                        No queued orders.
                                    </td>
                                </tr>
                            )}
                            {groups.map(group => (
                                <React.Fragment key={group.tradingsymbol}>
                                    <tr>
                                        <td className="positions-orders-table-cell">{group.tradingsymbol}</td>
                                        <td className="positions-orders-table-cell">{group.orders.length}</td>
                                        <td className="positions-orders-table-cell">
                                            <button onClick={() => this.toggleExpanded(group.tradingsymbol)}>
                                                {expanded === group.tradingsymbol ? "Hide JSON" : "View JSON"}
                                            </button>
                                        </td>
                                    </tr>
                                    {expanded === group.tradingsymbol && (
                                        <tr>
                                            <td className="positions-orders-table-cell json-viewer-cell" colSpan={3}>
                                                <pre className="json-viewer">{JSON.stringify(group.orders, null, 2)}</pre>
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export { groupByTradingsymbol };
export default QueuedOrders;
